import React, {Component} from 'react';
import {SimpleSelect} from 'react-selectize';
import {sortByProperty} from 'helpers/sorters';

function getOption(player) {
    return {value: player.playerId, label: player.name};
}

function getSelectedValue(value, players) {
    if (value) {
        for (const player of players) {
            if (player.playerId === value) {
                return getOption(player);
            }
        }
    }

    return '';
}

class SelectKeyPlayer extends Component {
    constructor(props) {
        super(props);
        const {value, players} = props;

        const selectedValue = getSelectedValue(value, players);

        this.state = {selectedValue};
    }
    onChange(selected) {
        this.props.onChange(selected !== undefined ? String(selected.value) : '');
        this.setState({selectedValue: selected});
    }
    sortedPlayers(players) {
        return players.sort(sortByProperty('salary', 'desc'));
    }
    getOptions() {
        const {players} = this.props;

        return this.sortedPlayers(players).map((player) => getOption(player));
    }
    render() {
        const {className = '', disabled} = this.props;

        return (
            <SimpleSelect
                className={className}
                defaultValue={''}
                options={this.getOptions()}
                placeholder={'Select player'}
                value={this.state.selectedValue}
                disabled={disabled}
                onValueChange={::this.onChange}
            />
        );
    }
}

export default SelectKeyPlayer;
